import { createSlice } from "@reduxjs/toolkit";
import { GroupsState } from "../entities/interfaces/groups-state.interface";
import getGroupsCases from "./cases/get-groups.cases";

const initialState: GroupsState = {
  groups: [],
  isLoadingGroups: false
};

const groupsSlice = createSlice({
  name: "groups/v2",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    getGroupsCases(builder);
  }
});

export default groupsSlice.reducer;
